export enum EPackageType {
  /** Общее предложение (Быстрая сделка, Vip-пакет) **/
  CommonOffer = 'commonOffer',
  /** Специальное предложение - сгенерировано на основе промокода **/
  SpecialOffer = 'specialOffer',
  /** Персональное предложение - будет генерироваться на отдельных условиях **/
  PersonalOffer = 'personalOffer',
  /** Общее предложение - подписки на публикации **/
  CommonSubscription = 'commonSubscription',
  /** Смарт-пакет **/
  SmartPackage = 'smartPackage',
  /** Пакет "Всё включено" */
  AllIn = 'allIn',
  /** Подписка */
  Subscription = 'subscription',
}
